import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=d194e2ec&"
import script from "./TeamMembers.vue?vue&type=script&lang=ts&"
export * from "./TeamMembers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports